// Where a conversation crosses midnight, say so.
//
// Messages carry only a time ("3:42 PM"), so a reply that arrived the next
// morning reads as if it came minutes later. A divider between messages from
// different LOCAL days gives the timeline back its days without stamping a
// date on every bubble.

/** The viewer's local calendar day for an instant — the unit dividers compare. */
export function dayKey(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** A divider belongs before a message that starts a new local day. */
export function needsDivider(prevIso: string | null | undefined, iso: string): boolean {
  if (!prevIso) return true;
  return dayKey(prevIso) !== dayKey(iso);
}

/**
 * What the divider says. "Today" and "Yesterday" because that is how people
 * think about recent days; a weekday+date inside the current year; the year
 * spelled out only once it is genuinely another year.
 */
export function dayDividerLabel(iso: string, now: Date = new Date()): string {
  const d = new Date(iso);
  const key = dayKey(iso);
  if (key === dayKey(now.toISOString())) return "Today";
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (key === dayKey(yesterday.toISOString())) return "Yesterday";
  if (d.getFullYear() === now.getFullYear()) {
    return d.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });
  }
  return d.toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" });
}
